import React from 'react'
import useSelection from '../hooks/use-selection'
import { useWillPipe } from '@morningtrain/react-helpers'

export default function ClearSelectionOnPipe () {
  const selection = useSelection()

  useWillPipe((payload) => {
    return new Promise(((resolve, reject) => {
        selection.clearSelected()
      resolve(payload)
    }))
  }, [selection])

  return null
}